/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { CALYPSO, GYPSUM, OZ, PANTERA } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FooterMicrocopy from 'pricing-pages-unified-ui/components/common/FooterMicrocopy';
import PriceDisplay from 'pricing-pages-unified-ui/components/common/pricing/PriceDisplay';
import SuiteCatalogEditionHeader from 'pricing-pages-unified-ui/components/crm-suite-catalog/SuiteCatalogEditionHeader';
import SuiteCatalogFeaturesTable from 'pricing-pages-unified-ui/components/crm-suite-catalog/SuiteCatalogFeaturesTable';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import partial from 'transmute/partial';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import UISelect from 'UIComponents/input/UISelect';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
const MODAL_WIDTH = 600;
const HEADER_HEIGHT = 128;
const MODAL_TOP_MARGIN = 60;
const MODAL_BOTTOM_MARGIN = 47;
const ModalHeader = styled.div.withConfig({
  displayName: "SuiteCatalogModal__ModalHeader",
  componentId: "sc-4stcv4-0"
})(["text-align:center;z-index:100;background-color:", ";padding:15px 0;& > h3{margin:0;}img{height:20px;}"], GYPSUM);
const PricingContainer = styled.div.withConfig({
  displayName: "SuiteCatalogModal__PricingContainer",
  componentId: "sc-4stcv4-1"
})(["margin:0 auto;"]);
const Price = styled.div.withConfig({
  displayName: "SuiteCatalogModal__Price",
  componentId: "sc-4stcv4-2"
})(["font-size:20px;color:", ";margin-right:8px;font-weight:600;display:inline-block;"], ({
  isDiscounted
}) => isDiscounted ? OZ : PANTERA);
const CrossedOutPrice = styled(PriceDisplay).withConfig({
  displayName: "SuiteCatalogModal__CrossedOutPrice",
  componentId: "sc-4stcv4-3"
})(["color:", ";font-size:16px;line-height:27px;text-decoration:line-through;"], PANTERA);
const CrossOutPerMonth = styled.span.withConfig({
  displayName: "SuiteCatalogModal__CrossOutPerMonth",
  componentId: "sc-4stcv4-4"
})(["font-size:16px;line-height:27px;text-decoration:line-through;"]);
const StyledSelect = styled(UISelect).withConfig({
  displayName: "SuiteCatalogModal__StyledSelect",
  componentId: "sc-4stcv4-5"
})(["width:fit-content;margin:8px auto 16px;font-size:26px;.private-dropdown__caret{font-size:20px;color:", ";margin-left:8px;}.crm-suite-bold{font-weight:700;}"], CALYPSO);

const SuiteCatalogModal = ({
  initialProductLevel,
  queryParamTerm,
  currencyCode,
  onCloseClick
}) => {
  const [activeProductLevel, setActiveProductLevel] = useState(initialProductLevel);

  const getOption = productLevel => {
    const text = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `pricingPage.pages.crmSuite.catalogModal.${productLevel.toLowerCase()}`
    });

    return {
      dropdownText: text,
      buttonText: text,
      value: productLevel
    };
  };

  const pricingInfo = useSelector(state => {
    const productConfigurations = suiteProductConfigurationsSelector(state, {
      productLevel: activeProductLevel
    });
    return calculatedPriceSelector(state, {
      productConfigurations,
      queryParamTerm
    });
  });
  const isDiscounted = pricingInfo.monthly.calculatedPrice < pricingInfo.monthly.fullPrice;

  const handleProductLevelChange = evt => {
    getUsageTracker().track('modalInteraction', {
      action: 'changed product level',
      modalName: 'suite-catalog-modal',
      productLevel: evt.target.value
    });
    setActiveProductLevel(evt.target.value);
  };

  const renderModalHeader = () => {
    return /*#__PURE__*/_jsxs(ModalHeader, {
      children: [/*#__PURE__*/_jsxs(H3, {
        className: "display-inline",
        children: [/*#__PURE__*/_jsx(StyledSelect, {
          buttonUse: "unstyled",
          onChange: handleProductLevelChange,
          options: Object.keys(CRM_SUITE_PRODUCTS).map(productLevel => getOption(productLevel)),
          value: activeProductLevel,
          searchable: false,
          menuWidth: "auto"
        }), /*#__PURE__*/_jsxs(PricingContainer, {
          children: [/*#__PURE__*/_jsxs(Price, {
            isDiscounted: isDiscounted,
            children: [/*#__PURE__*/_jsx(PriceDisplay, {
              price: pricingInfo.monthly.calculatedPrice,
              currencyCode: currencyCode
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.planBuilder.priceDisplay.perMonth"
            })]
          }), isDiscounted && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(CrossedOutPrice, {
              price: pricingInfo.monthly.fullPrice,
              currencyCode: currencyCode
            }), /*#__PURE__*/_jsx(CrossOutPerMonth, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.planBuilder.priceDisplay.perMonth"
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: partial(onCloseClick)
      })]
    });
  };

  const renderGrowthHubEditionTable = productLine => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SuiteCatalogEditionHeader, {
        productLevel: activeProductLevel,
        productLine: productLine,
        queryParamTerm: queryParamTerm
      }), /*#__PURE__*/_jsx(SuiteCatalogFeaturesTable, {
        productLevel: activeProductLevel,
        productLine: productLine
      })]
    }, productLine);
  };

  const hubsInCrmSuiteTier = CRM_SUITE_PRODUCTS[activeProductLevel];
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: MODAL_WIDTH,
    children: [renderModalHeader(), /*#__PURE__*/_jsxs(UIScrollContainer, {
      maxHeight: `calc(100vh - ${HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN}px)`,
      scrollDirection: 'vertical',
      children: [hubsInCrmSuiteTier.map(productLine => {
        return renderGrowthHubEditionTable(productLine);
      }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
    })]
  });
};

SuiteCatalogModal.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  initialProductLevel: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  queryParamTerm: PropTypes.string
};
export default SuiteCatalogModal;